import {t} from "i18next";
import React, {useRef, useState} from "react";
import {useCookies} from "react-cookie";
import {appIsEmbedded} from "../Utils/appIsEmbedded";

const COOKIE_AGE = 48 * 60 * 60;

export const LoginForm  = (props) => {
    const usernameRef = useRef(null);
    const [, setCookie] = useCookies([]);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [unauthorized, setUnauthorized] = useState(false);

    function credentialsAreValid (username, password) {
        return username === process.env.REACT_APP_USERNAME && password === process.env.REACT_APP_PASSWORD;
    }

    function handleSubmit(e) {
        e.preventDefault();


        if (credentialsAreValid(username, password)) {
            console.log("Hi admin! Redirecting...");
            setCookie('jm_authorized','true', { maxAge: COOKIE_AGE });
            window.location.reload();
        
        } else {
            usernameRef.current.focus();
            setUsername("");
            setPassword("");

            
            if(appIsEmbedded()) {
                setUnauthorized(true); // Show unauthorized message
            }
        }
    }

    if(unauthorized) {
        return (
            <div className="unauthorized-wrapper">
                <p className={'h3'}>403 | {t("unauthorized")}</p>
            </div>
        );
    }

    return (
        <div className="login-wrapper">
            <form id={'loginform'} onSubmit={handleSubmit}>
                <div className="form-field">
                    {/*<label htmlFor="username">Usuario</label>*/}
                    <input
                        ref={usernameRef}
                        id="username"
                        type="text"
                        placeholder={t("username")}
                        value={username}
                        onChange={(e) => { setUsername(e.target.value); }}
                        autoFocus={true}
                    />
                </div>
                <div className="form-field">
                    {/*<label htmlFor="password">Contraseña</label>*/}
                    <input
                        id="password"
                        type="password"
                        placeholder={t("password")}
                        value={password}
                        onChange={(e) => { setPassword(e.target.value); }}
                    />
                </div>
                <div className="form-actions">
                    <button type="submit" onClick={(e) => handleSubmit(e)}>{t("enter")}</button>
                </div>
            </form>
        </div>
    );

}